module.exports = __webpack_public_path__ + "img/img-4.a0b9c201.webp";